"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const vue_1 = __importDefault(require("vue"));
class Http {
    constructor(options = {}) {
        this.inst = axios_1.default.create({
            baseURL: process.env.VUE_APP_API_URL,
            timeout: 100000,
            withCredentials: true
        });
        this.addRequestInterceptor(options);
        this.addResponseInterceptor(options);
    }
    addRequestInterceptor(options) {
        this.inst.interceptors.request.use(req);
        function req(cfg) {
            if (options.requestHandler)
                options.requestHandler(cfg);
            //console.log('777',cfg.url)
            if (cfg.url != "/home/index" && cfg.url != "/base/getList" && cfg.url != "/news/list" && cfg.url != "/news/detail" && cfg.url != "/protocol/content" && cfg.url != "/consultRec/insert") {
                let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '';
                if (userInfo) {
                    let data = cfg.data || {};
                    data.loginToken = userInfo.loginToken;
                    cfg.data = data;
                }
            }
            return cfg;
        }
    }
    addResponseInterceptor(options) {
        const vm = this;
        this.inst.interceptors.response.use(res);
        function res(response) {
            if (response.status === 200) {
                if (Object.prototype.toString.call(response.data) !== '[object Object]')
                    return Promise.resolve(response.data); // TODO 可进一步优化
                const { code, content, msg } = response.data;
                const tkd = (response.data && response.data.content && response.data.content.tkd) || '';
                // console.log('tdk',tkd)
                if (tkd) {
                    document.querySelector('meta[name="keywords"]').setAttribute('content', tkd.keywords);
                    document.querySelector('meta[name="description"]').setAttribute('content', tkd.description);
                    document.title = tkd.title;
                }
                if (+code === +(options.successCode || 1)) {
                    return Promise.resolve(content);
                }
                else if (+code === +(options.expiredCode || 2)) {
                    vm.message(msg);
                    return Promise.reject(response);
                }
                else {
                    vm.message(msg);
                    localStorage.setItem('userInfo', '');
                    localStorage.setItem('carNum', '');
                    vue_1.default.prototype.$auth.toLogin();
                    return Promise.reject(response);
                }
            }
            else {
                vm.message(response.statusText);
                return Promise.reject(response);
            }
        }
    }
    message(msg) {
        if (vue_1.default.prototype.$notify) {
            vue_1.default.prototype.$notify({
                title: 'System error',
                message: msg,
                type: 'error'
            });
        }
        else {
            alert(Text);
        }
    }
    getUri(config) {
        return this.inst.getUri(config);
    }
    request(config) {
        return this.inst.request(config);
    }
    get(url, config) {
        return this.inst.get(url, config);
    }
    delete(url, config) {
        return this.inst.delete(url, config);
    }
    head(url, config) {
        return this.inst.head(url, config);
    }
    post(url, data, config) {
        return this.inst.post(url, data, config);
    }
    put(url, data, config) {
        return this.inst.put(url, data, config);
    }
    patch(url, data, config) {
        return this.inst.patch(url, data, config);
    }
}
exports.default = Http;
